import type { Point2d } from "../../../../common/geometry/Geom2d";

import TabletopPositionalElement from "./TabletopPositionalElement";
import IRectangularElement from "../../../../common/elements/geom/IRectangularElement";

export default abstract class TabletopDimensionalElement
    extends TabletopPositionalElement
    implements IRectangularElement
{
    protected _width: number | (() => number);
    protected _height: number | (() => number);

    constructor(args?: {
        x?: number | (() => number);
        y?: number | (() => number);
        width?: number | (() => number);
        height?: number | (() => number);
    }) {
        super({ x: args?.x ?? 0, y: args?.y ?? 0 });

        this._width = args?.width ?? 1;
        this._height = args?.height ?? 1;
    }

    public get width(): number {
        if (typeof this._width === "number") {
            return this._width;
        }

        return this._width();
    }

    public get height(): number {
        if (typeof this._height === "number") {
            return this._height;
        }

        return this._height();
    }

    public override get right(): number {
        return this.x + this.width;
    }

    public override get bottom(): number {
        return this.y + this.height;
    }

    public set width(val: number) {
        this._width = val;
    }

    public set height(val: number) {
        this._height = val;
    }

    public containsPoint(point: Point2d): boolean {
        return (
            point.x >= this.left &&
            point.x <= this.right &&
            point.y >= this.top &&
            point.y <= this.bottom
        );
    }

    /** Returns true if otherElement's bounds and this element's bounds intersect at any point */
    public overlaps(otherElement: TabletopPositionalElement) {
        if (
            (this.left >= otherElement.left &&
                this.left <= otherElement.right) ||
            (this.right >= otherElement.left &&
                this.right <= otherElement.right) ||
            (otherElement.left >= this.left &&
                otherElement.left <= this.right) ||
            (otherElement.right >= this.left &&
                otherElement.right <= this.right)
        ) {
            if (
                (this.top >= otherElement.top &&
                    this.top <= otherElement.bottom) ||
                (this.bottom >= otherElement.top &&
                    this.bottom <= otherElement.bottom) ||
                (otherElement.top >= this.top &&
                    otherElement.top <= this.bottom) ||
                (otherElement.bottom >= this.top &&
                    otherElement.bottom <= this.bottom)
            ) {
                return true;
            }
        }

        return false;
    }
}
